import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { Adempimento } from '../../../common/models/adempimento';
import { SearchAdempimentiResponse } from '../../../common/models/dto/search-adempimenti-response';
import { UrlSettingsCore } from '../../configuration/url-settings-core';
import { RefreshHeader } from '../../models/refresh-header';
import { OperationsService } from '../../services/operations.service';
import { ViewManagerService } from '../../services/view-manager-service';
import { AppData } from 'src/app/data-store';

@Component({
  selector: '[adempimenti-inevasi]',
  templateUrl: 'adempimenti-inevasi.component.html',
  styleUrls: ['./adempimenti-inevasi.component.css']
})

export class AdempimentiInevasiComponent implements OnInit {

  viewAll: string = UrlSettingsCore.URL_ADEMPIMENTI_INEVASI;
  numToView: number = 5;
  adempimenti: Adempimento[] = [];
  numNotifiche: number = 0;
  polling: boolean = true;
  subscriptionAdempimentiInevasi: Subscription;
  @Output() onClick = new EventEmitter();

  constructor(private viewManager: ViewManagerService,
              protected operationService: OperationsService) {}

  ngOnInit() {
    this.subscriptionAdempimentiInevasi = this.viewManager.adempimentiInevasi.subscribe(param => this.refreshAdempimenti(param));
    if(!AppData.getInstance().adempimentiInevasi) {
      this.loadAdempimentiInevasi();
    } else {
      this.adempimentiInevasiListResult(AppData.getInstance().adempimentiInevasi);
    }
  }

  private refreshAdempimenti(response?: RefreshHeader) {
    this.adempimenti = [];
    let model = this;
    if(response && response.param){
      this.adempimentiInevasiListResult(response.param)
    }else{
      this.loadAdempimentiInevasi(response ? response.timeOut : false);
    }
  }

  private loadAdempimentiInevasi(timeOut: boolean = false) {
    let getNotifications;
    let model = this;
    if (this.polling) {
      this.operationService.getAdempimentiInevasi({fromResult: this.adempimenti.length}).
        subscribe(response => {
          AppData.getInstance().adempimentiInevasi = response;
          this.adempimentiInevasiListResult(response);
          if(timeOut){
            this.viewManager._refreshNotifiche.next({param: null, timeOut: true});
          }
        });
    }
  }

  private adempimentiInevasiListResult(response: SearchAdempimentiResponse) {
    if (response.adempimenti && response.adempimenti.length > 0) {
      AppData.getInstance().adempimentiInevasi = response;
      let responseAdempimenti = response.adempimenti;
      this.adempimenti = this.adempimenti.concat(responseAdempimenti);
      this.numNotifiche = response.setNumeroAdempimentiTotali;
    } else {
      this.numNotifiche = 0;
    }
  }

  ngOnDestroy() {
    this.polling = false;
  }

  getAriaLabel() {
    if(this.numNotifiche > 0) {
      return "Sono presenti " + this.numNotifiche + " " + "adempimenti inevasi";
    } else {
      return "Non ci sono adempimenti inevasi";
    }
  }
}
